import apiService from "./apiService";

const adminService = {
    async broadcastMessage(message) {
        try {
            const resp = await apiService.post(`admin/broadcast`, message, true);
            return resp.data;
        }
        catch {
            return { success: false, message: 'An error occured while processing the request.' };
        }
    },
      async broadcastMessageToUser(id,message) {
        try {
            const resp = await apiService.post(`admin/${id}/broadcast`, message, true);
            return resp.data;
        }
        catch {
            return { success: false, message: 'An error occured while processing the request.' };
        }
    },
}

export default adminService;